<template>
  <!--  计时烹饪模板-->
  <DetailContainer>
    <PageHeader
      slot="page-header"
      showBack
      showBreadcrumb
      @back="$router.push({ name: 'RecipeList' })"
    ></PageHeader>
    <CardContainer>
      <el-container>
        <el-aside width="220px">
          <div class="menuDiv">
            <el-menu
              default-active="basicInfo"
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose"
              @select="goDetail"
            >
              <el-menu-item index="basicInfo">
                <div class="menuItem">
                  <svg class="icon icon--default">
                    <use :xlinkHref="'#' + icon + '-' + this.theme"></use>
                  </svg>
                  <svg class="icon icon--selected">
                    <use :xlinkHref="'#' + icon + '-select'"></use>
                  </svg>
                  <span>{{ $t('Common.BasicInfo') }}</span>
                </div>
              </el-menu-item>
              <el-menu-item index="listFoodInfo">
                <div class="menuItem">
                  <svg class="icon icon--default">
                    <!--                  <use xlinkHref={'#' + icon + '-' + this.theme}></use>-->
                    <use :xlinkHref="'#' + icon + '-' + this.theme"></use>
                  </svg>
                  <svg class="icon icon--selected">
                    <use :xlinkHref="'#' + icon + '-select'"></use>
                  </svg>
                  <span>{{ $t('RecipeManage.listFoodInfo') }}</span>
                </div>
              </el-menu-item>
              <el-menu-item index="listPreheateInfo">
                <div class="menuItem">
                  <svg class="icon icon--default">
                    <!--                  <use xlinkHref={'#' + icon + '-' + this.theme}></use>-->
                    <use :xlinkHref="'#' + icon + '-' + this.theme"></use>
                  </svg>
                  <svg class="icon icon--selected">
                    <use :xlinkHref="'#' + icon + '-select'"></use>
                  </svg>
                  <span>{{ $t('RecipeManage.listPreheateInfo') }}</span>
                </div>
              </el-menu-item>
              <el-menu-item index="listRecipeStage">
                <div class="menuItem">
                  <svg class="icon icon--default">
                    <!--                  <use xlinkHref={'#' + icon + '-' + this.theme}></use>-->
                    <use :xlinkHref="'#' + icon + '-' + this.theme"></use>
                  </svg>
                  <svg class="icon icon--selected">
                    <use :xlinkHref="'#' + icon + '-select'"></use>
                  </svg>
                  <span>{{ $t('RecipeManage.listRecipeStage') }}</span>
                </div>
              </el-menu-item>
            </el-menu>
          </div>
          <!--          </div>-->
        </el-aside>
        <el-container>
          <el-header style="text-align: right; font-size: 12px;">
            <el-tabs v-model="activeLang" @tab-click="handleActiveLang" class="selfTabs">
              <el-tab-pane
                v-for="(item, index) in langList"
                :key="index"
                :label="item.name"
                :name="item.code"
              ></el-tab-pane>
            </el-tabs>
          </el-header>
          <el-main style="height: 70vh; overflow-y: auto">
            <div>
              <!--      基本信息-->
              <div id="basicInfo">
                <div class="title-div">
                  <div class="content">{{ $t('Common.BasicInfo') }}</div>
                  <div class="backColor"></div>
                </div>
                <Description>
                  <DescriptionItem
                    :span="12"
                    :labelWidth="'120px'"
                    :label="$t('RecipeManage.listRecipeName')"
                    >{{
                      detailInfo && detailInfo.name ? detailInfo.name : format(detailInfo.name)
                    }}</DescriptionItem
                  >
                  <DescriptionItem
                    :span="12"
                    :labelWidth="'120px'"
                    :label="$t('RecipeManage.listApplicableModel')"
                    >{{
                      detailInfo.productNames
                        ? detailInfo.productNames.join()
                        : format(detailInfo.productNames)
                    }}</DescriptionItem
                  >
                  <DescriptionItem
                    :span="24"
                    :labelWidth="'120px'"
                    :label="$t('RecipeManage.listRecipeType')"
                    >{{
                      detailInfo.typeName ? detailInfo.typeName : format(detailInfo.typeName)
                    }}</DescriptionItem
                  >
                  <DescriptionItem
                    :span="24"
                    :labelWidth="'120px'"
                    :label="$t('RecipeManage.listRecipeImg')"
                  >
                    <div class="imgDiv">
                      <div class="imgItem">
                        <hl-image
                          :src="
                            detailInfo.iconBig
                              ? createImgUrl(detailInfo.iconBig)
                              : require('@/assets/pic_default.jpg')
                          "
                          alt=""
                          width="160px"
                          height="108px"
                          class="imgBig"
                        ></hl-image>
                        <div class="imgTip">{{ $t('RecipeManage.listBigImg') }}</div>
                      </div>
                      <!--                      <div class="imgItem">
                        <hl-image
                          :src="
                            detailInfo.iconBig
                              ? createImgUrl(detailInfo.iconSmall)
                              : require('@/assets/pic_default.jpg')
                          "
                          alt=""
                          width="140px"
                          height="94px"
                          class="imgSmall"
                        ></hl-image>
                        <div class="imgTip">{{ $t('RecipeManage.listSmallImg') }}</div>
                      </div>-->
                    </div>
                  </DescriptionItem>
                  <DescriptionItem
                    :span="24"
                    :labelWidth="'120px'"
                    :label="$t('RecipeManage.listRecipeDescription')"
                  >
                    <el-tooltip effect="dark" placement="top" p>
                      <template slot="content">
                        <p style="max-width:500px;">
                          {{
                            detailInfo.description
                              ? detailInfo.description
                              : format(detailInfo.description)
                          }}
                        </p>
                      </template>
                      <div
                        style="width:600px;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                      >
                        {{
                          detailInfo.description
                            ? detailInfo.description
                            : format(detailInfo.description)
                        }}
                      </div>
                    </el-tooltip>
                  </DescriptionItem>
                </Description>
              </div>

              <!--      食材信息-->
              <div style="margin-top: 40px" id="listFoodInfo">
                <div class="title-div">
                  <div class="content">
                    {{ $t('RecipeManage.listFoodInfo') }}
                  </div>
                  <div class="backColor"></div>
                </div>
                <div style="display: flex;flex-wrap:wrap">
                  <!--                  v-for='(item,index) in detailInfo.ingredientDetailDtos' :key='index'-->
                  <div
                    class="foodInfo"
                    v-for="(item, index) in detailInfo.ingredientDetailDtos"
                    :key="index"
                  >
                    <div class="indexNum">
                      {{ index + 1 }}
                    </div>
                    <div class="foodDetail">
                      <div class="foodName">{{ item.ingredientName }}</div>
                      <div class="foodNum">
                        <span class="num">{{ item.count }}</span>
                        <span class="unit">{{ item.unit }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--             预热信息-->
              <div style="margin-top: 40px" id="listPreheateInfo">
                <div class="title-div">
                  <div class="content">{{ $t('RecipeManage.listPreheateInfo') }}</div>
                  <div class="backColor"></div>
                </div>
                <Description>
                  <DescriptionItem
                    :labelWidth="'120px'"
                    :span="24"
                    :label="$t('RecipeManage.listPreheateModal')"
                  >
                    {{
                      listPreheateOption.find((item) => item.value === detailInfo.preheatingMode)[
                        'label'
                      ]
                    }}
                    <span style="padding-left: 8px" v-if="detailInfo.preheatingMode === 'CUSTOM'"
                      >{{
                        detailInfo.preheatingTemperature | format(detailInfo.preheatingTemperature)
                      }}℃</span
                    >
                  </DescriptionItem>
                </Description>
              </div>
              <!--             菜谱阶段-->
              <div style="margin-top: 40px" id="listRecipeStage">
                <div class="title-div">
                  <div class="content">{{ $t('RecipeManage.listRecipeStage') }}</div>
                  <div class="backColor"></div>
                </div>
                <div class="secondTitle">
                  {{ $t('RecipeManage.liststageList') }}
                </div>
                <div class="stageListDiv">
                  <div class="stageList" v-for="(item, i) in detailInfo.cookbookFlowDtos" :key="i">
                    <div
                      :class="activeCookStage === i ? 'activeStage' : 'normalStage'"
                      @click="selectCookStage(i)"
                    >
                      <div>
                        <div class="text">
                          {{ `${$t('Common.stage')}  ${i + 1}` }}
                          {{ item.name }}
                        </div>
                      </div>
                    </div>
                    <div class="iconConn" v-if="i !== detailInfo.cookbookFlowDtos.length - 1">
                      <div class="bridge"></div>
                      <!--                      <i class="iconDIV el-icon-back" :style='"margin-right:-8px"'></i>-->
                    </div>
                  </div>
                </div>

                <div v-if="cookPhaseObj.flowType === 'TIMEKEEPING' && reFresh">
                  <DetailTime :ref="'DetailTime'" :cookPhaseObj="this.cookPhaseObj"></DetailTime>
                </div>
                <div v-if="cookPhaseObj.flowType === 'MEDIUM_CODE_PROBE' && reFresh">
                  <DetailMid :ref="'DetailMid'" :cookPhaseObj="this.cookPhaseObj"></DetailMid>
                </div>
                <div v-if="cookPhaseObj.flowType === 'TEMPERATURE_DIFF' && reFresh">
                  <DetailDiff :ref="'DetailDiff'" :cookPhaseObj="this.cookPhaseObj"></DetailDiff>
                </div>
                <div v-if="cookPhaseObj.flowType === 'FACTORY_PRESET' && reFresh">
                  <DetailPre :ref="'DetailPre'" :cookPhaseObj="this.cookPhaseObj"></DetailPre>
                </div>
              </div>
            </div>
          </el-main>
        </el-container>
      </el-container>
    </CardContainer>
  </DetailContainer>
</template>

<script>
import { createImgUrl, getCountryName } from '@/utils/utils'
import DetailTime from './components/DetailTime'
import DetailMid from './components/DetailMid'
import DetailDiff from './components/DetailDiff'
import DetailPre from './components/DetailPre'
import { languageList } from '@/config/status.js'
import Description from '@/components/Descriptions'
import DescriptionItem from '@/components/Descriptions/DescriptionsItem'
import { format } from '@/utils/utils'
import Image from '@/components/CommonTable/Image'
export default {
  name: 'RecipeDetail',
  components: {
    DetailPre,
    DetailMid,
    DetailTime,
    DetailDiff,
    Description,
    DescriptionItem,
    'hl-image': Image
  },
  data() {
    return {
      detailInfo: {},
      activeLang: '',
      langList: [],
      active: 0, // 当前激活的导航索引
      ingredientDetailDtos: [],
      cookbookFlowDtos: [],
      form: {
        preheatingMode: 'CUSTOM',
        language: localStorage.getItem('locale') === 'zh' ? 'chinese' : 'english'
      },
      rules: {
        name: [{ required: true, message: this.$t('RecipeManage.listRecipeName'), trigger: 'blur' }]
      },
      cookPhaseObj: {},
      listPreheateOption: [
        {
          value: 'NOTHING',
          label: this.$t('RecipeManage.listPreheateOption1')
        },
        {
          value: 'CUSTOM',
          label: this.$t('RecipeManage.listPreheateOption2')
        },
        {
          value: 'LOW',
          label: this.$t('RecipeManage.listPreheateOption3')
        },
        {
          value: 'MIDDLE',
          label: this.$t('RecipeManage.listPreheateOption4')
        },
        {
          value: 'HIGH',
          label: this.$t('RecipeManage.listPreheateOption5')
        }
      ],
      activeCookStage: 0,
      langTableData: {},
      selectDiv: 'basicInfo',
      languageList,
      cookbookId: this.$route.query.id,
      reFresh: true
    }
  },
  created() {
    if (this.$route.query.lang) {
      console.log('1')
      let arr = []
      let obj = {
        code: this.$route.query.lang,
        name: ''
      }
      obj['name'] = getCountryName(this.$route.query.lang).name
      arr.push(obj)

      this.langList = arr
      this.activeLang = arr[0].code

      let res = JSON.parse(localStorage.getItem('previewData'))
      console.log('res', res)
      //预览
      this.detailInfo = res
      if (res.cookbookFlowDtos.length > 0) {
        this.selectCookStage(0)
      }

      localStorage.removeItem('preViewData')
    } else {
      //查看详请
      this.queryLang()
    }
  },
  methods: {
    format,
    createImgUrl,
    handleActiveLang() {
      console.log(this.activeLang)
      this.getDetail(this.activeLang)
    },
    queryLang() {
      const params = {
        id: this.cookbookId
      }
      this.$ajax.get(this.$api.recipe.count_cookbook_lang, params).then((res) => {
        if (res.data) {
          let arr = []
          res.data.forEach((item) => {
            let obj = {
              code: item,
              name: ''
            }
            obj['name'] = getCountryName(item).name
            arr.push(obj)
          })

          this.langList = arr
          this.activeLang = arr[0].code
          this.getDetail(arr[0].code)
        }
      })
    },
    getDetail(language) {
      const params = {
        id: this.cookbookId,
        language: language
      }
      this.$ajax.get(this.$api.recipe.detail_cookbook, params).then((res) => {
        if (res.data) {
          this.detailInfo = res.data
          if (res.data.cookbookFlowDtos.length > 0) {
            this.selectCookStage(0)
          }
        }
      })
    },

    //锚点跳转
    goDetail(id) {
      let anchor = document.getElementById(id)
      anchor.scrollIntoView()
    },
    //选择菜谱阶段
    selectCookStage(i) {
      this.reFresh = false
      this.activeCookStage = i
      let obj = this.detailInfo.cookbookFlowDtos[i]
      obj.index = i
      this.cookPhaseObj = obj
      this.$nextTick(() => {
        this.reFresh = true
      })
    },

    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    handleProductChange(product) {
      this.form.productNames = product.name
    }
  }
}
</script>

<style lang="scss" scoped>
.info {
  margin-left: 24px;
}
.el-menu {
  border-right: 0;
  .el-menu-item {
    height: 40px;
    line-height: 40px;
    min-width: auto;
    border-radius: 6px;
    &.is-active {
      //background: rgba(51, 157, 255, 0.1) !important;
      background: rgba(32, 70, 199, 0.1) !important;
      span {
        position: relative;
        font-weight: 500;
        &::before {
          content: '';
          position: absolute;
          left: -24px;
          top: 4px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          border-width: 2px;
          border-style: solid;
          vertical-align: middle;
          box-sizing: border-box;
        }
      }
    }
  }
}

.title-div {
  margin-bottom: 24px;
  .content {
    font-size: 24px;
    font-weight: 600;
    color: #333333;
    line-height: 32px;
    span {
      font-size: 24px;
      font-weight: 400;
      color: #666666;
      line-height: 32px;
      padding-left: 8px;
    }
  }
  .backColor {
    width: 100px;
    margin-top: -10px;
    height: 10px;
    background: linear-gradient(90deg, #2046c7 0%, rgba(127, 156, 255, 0) 100%);
    border-radius: 100px 0px 0px 100px;
  }
}
.elTableSelect {
  .el-input {
    width: 180px !important;
  }
}
.elTableInput {
  width: 160px !important;
}
.secondTitle {
  font-weight: 600;
  color: #333333;
  line-height: 22px;
  margin: 16px auto 8px auto;
}
.stageListDiv {
  display: flex;
  max-width: 90%;
  overflow-x: auto;
  padding: 16px 0;
  .stageList {
    display: flex;
    .activeStage {
      z-index: 2;
      width: 100px;
      height: 54px;
      background: #2046c7;
      border-radius: 8px;
      border: 2px solid #2046c7;
      line-height: 54px;
      text-align: center;
      font-weight: 600;
      color: #ffffff;
      cursor: pointer;
    }
    .normalStage {
      z-index: 2;
      width: 100px;
      height: 54px;
      background: #ffffff;
      border-radius: 8px;
      border: 2px solid #bcc7ee;
      font-weight: 600;
      color: #333333;
      line-height: 54px;
      text-align: center;
      cursor: pointer;
      &:hover {
        background: #f0f2fc;
        border-radius: 8px;
        border: 2px solid #8fa2e3;
        color: #2046c7;
      }
    }
    .delButton {
      position: relative;
      margin-left: -10px;
      margin-top: -4px;
      z-index: 3;
      width: 16px;
      height: 16px;
      background-image: url('../../../assets/error.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      cursor: pointer;
      //position: fixed;
    }
    .iconConn {
      position: relative;
      margin-left: -10px;
      display: flex;
      height: 54px;
      align-items: center;
      .bridge {
        width: 40px;
        height: 8px;
        border-radius: 4px;
        //background: #e8e8e8;
        margin: 0 -4px;
        z-index: 1;
        background-image: url('../../../assets/cookbook_icon_stage_arrow.svg');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
      }
      .iconDIV {
        z-index: 10;
        width: 16px;
        height: 16px;
        border: 1px solid #8fa2e3;
        border-radius: 8px;
        background: #ffffff;
        color: #2046c7;
        cursor: pointer;
        &:hover {
          background: #f0f2fc;
          border-radius: 12px;
          width: 24px;
          height: 24px;
          font-size: 18px;
          line-height: 20px;
          border: 2px solid #bcc7ee;
          color: #637dd7;
        }
      }
    }
  }
}

.el-aside {
  border-right: 1px solid #e8e8e8;
  .menuDiv {
    width: 190px;
    margin-right: 24px;
    .menuItem {
      margin-left: -10px;
    }
  }
}
.foodInfo {
  width: 204px;
  height: 74px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  display: flex;
  padding-left: 8px;
  padding-top: 12px;
  margin-right: 16px;
  margin-bottom: 16px;
  .indexNum {
    font-size: 36px;
    font-family: Barlow-SemiBoldItalic, Barlow;
    font-weight: normal;
    color: #bcc7ee;
    //line-height: 44px;
    margin-right: 8px;
  }
  .foodDetail {
    .foodName {
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      margin-bottom: 8px;
    }
    .foodNum {
      .num {
        color: #666666;
        padding-right: 4px;
      }
      .unit {
        color: #999999;
      }
    }
  }
}
.imgDiv {
  display: flex;
  .imgItem {
    text-align: center;
    margin-right: 24px;
    .imgTip {
      color: #999999;
    }
    .imgBig {
      width: 160px;
      height: 108px;
      border-radius: 4px;
    }
    .imgSmall {
      width: 140px;
      height: 94px;
      border-radius: 4px;
      margin: 8px auto;
    }
  }
  /deep/ .selfTabs {
    box-shadow: 0 5px 10px -5px rgba(215, 222, 230, 0.4);
  }
  /deep/ .desTooltips {
    max-width: 200px !important;
  }
}
</style>
